(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-start.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-start.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  sweRectangleBounds,
  worldRectangleBounds,
  mapDefaults,
  get3dPinIcon,
  createMap
} = svs.tur.lyckoplatsen.map;
const logger = svs.core.log.getLogger('module:lyckoplatsen');
function getStartMapHandler() {
  let map;
  let options;
  let results;
  let sweRec;
  let tlEnd;
  let markers = [];
  let circles = [];

  let _isDestroying = false;
  let isClickInProgress = false;
  return {
    createMap(mapOptions) {
      var _svs$lyckoplatsen$dat, _svs$lyckoplatsen$dat2;
      options = _objectSpread(_objectSpread({}, mapDefaults), mapOptions);
      map = createMap(options);
      results = (_svs$lyckoplatsen$dat = (_svs$lyckoplatsen$dat2 = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat2 === void 0 || (_svs$lyckoplatsen$dat2 = _svs$lyckoplatsen$dat2.startPage) === null || _svs$lyckoplatsen$dat2 === void 0 ? void 0 : _svs$lyckoplatsen$dat2.recentResults) !== null && _svs$lyckoplatsen$dat !== void 0 ? _svs$lyckoplatsen$dat : [];
      this.addElements();
      this.mapFitBounds();
      this.animateIntroFadeIn();
      this.mapOnClick();
      this.animatePlacesLoop();
      this.mapOnClick();
      return map;
    },
    mapFitBounds() {
      if (map && sweRec) {
        const pb = svs.core.detect.breakpoint.equals('xs') ? [0, 134] : [0, 160];
        const pt = svs.core.detect.breakpoint.equals('xs') ? [0, 80] : [0, 112];
        map.fitBounds(sweRec.getBounds(), {
          paddingBottomRight: pb,
          paddingTopLeft: pt,
          animate: false
        });
      }
    },
    mapOnClick() {
      map.on('click', e => {
        if (isClickInProgress) {
          return;
        }
        isClickInProgress = true;
        const clickedPoint = [e.latlng.lat, e.latlng.lng];
        const swePath = svs.tur.lyckoplatsen.map.swe;
        const isInsideSweden = svs.tur.lyckoplatsen.map.isPointInsideSweden(clickedPoint, swePath.features[0].geometry.coordinates);
        const lat = e.latlng.lat.toFixed(6);
        const lng = e.latlng.lng.toFixed(6);
        const urlPlay = svs.core.urlMapping.get('lyckoplatsen_Play');
        const urlWithParams = "".concat(urlPlay, "?coords=").concat(lat, ",").concat(lng);
        if (isInsideSweden) {
          this.trackStartMapClick();
          this.placeStartClickCircle(clickedPoint, urlWithParams);
        } else {
          this.placeErrorCircle(clickedPoint);
          isClickInProgress = false;
        }
      });
    },
    trackStartMapClick() {
      svs.components.analytics.trackEvent({
        category: 'Lyckoplatsen',
        action: 'map_click',
        opt_label: 'startpage'
      });
    },
    circleAnimate(tl) {
      let slowdown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      tl.timeScale(slowdown);
      tl.set(".circle-animate", {
        opacity: 0,
        scale: 0,
        transformOrigin: '50% 50%'
      });
      tl.to(".circle-animate", {
        scale: 1,
        duration: 0.4,
        ease: 'back.out(1.2)'
      }, '<');
      tl.to(".circle-animate", {
        opacity: 0.25,
        duration: 0.25
      }, '<');
      tl.to(".circle-animate", {
        opacity: 0,
        duration: 0.15,
        delay: 0.25
      }, '<');
    },
    removeCircle(circle) {
      circle.remove();
    },
    placeStartClickCircle(location, urlWithParams) {
      const circle = leaflet.circleMarker(location, {
        color: '#2073e5',
        radius: 30,
        weight: 0,
        fillOpacity: 1,
        className: 'cirlce-from-start circle-animate'
      });
      circle.addTo(map);
      const tl = gsap.timeline({
        onStart: () => gsap.to('.leaflet-results-pane', {
          opacity: 0,
          duration: 0.75,
          ease: 'power1.out'
        }),
        onComplete: () => {
          this.removeCircle(circle);
          svs.utils.url.navigate(urlWithParams);
        }
      });
      this.circleAnimate(tl, 0.4);
      return circle;
    },
    placeErrorCircle(location) {
      const circle = leaflet.circleMarker(location, {
        color: 'red',
        radius: 20,
        weight: 0,
        fillOpacity: 1,
        className: 'cirlce-error circle-animate'
      });
      circle.addTo(map);
      const tl = gsap.timeline({
        onComplete: () => this.removeCircle(circle)
      });
      this.circleAnimate(tl);
      return circle;
    },
    animateReset() {
      gsap.killTweensOf('.gsap-result-text-top');
      gsap.killTweensOf('.gsap-png-marker');
      gsap.killTweensOf('.gsap-winner-circle');
      gsap.set('.gsap-result-text-top', {
        opacity: 0,
        y: 24
      });
      gsap.set('.gsap-png-marker', {
        opacity: 0,
        scale: 0
      });
      gsap.set('.gsap-winner-circle', {
        opacity: 0
      });
      if (tlEnd) {
        tlEnd.kill();
        tlEnd = null;
      }
    },
    animatePlay() {
      this.animateReset();
      this.animateIntroFadeIn();
      this.animatePlacesLoop();
    },
    animateIntroFadeIn() {
      gsap.set('.gsap-result-text-top', {
        opacity: 0,
        y: 0
      });
      gsap.set('.gsap-start-overlay-pane', {
        opacity: 1
      });
      gsap.to('.gsap-result-text-top', {
        opacity: 1,
        y: 0,
        delay: 1.5,
        duration: 1,
        ease: 'power3.out'
      });
      gsap.to('.gsap-start-overlay-pane', {
        opacity: 0,
        delay: 1.5,
        duration: 1,
        ease: 'power3.out'
      });
    },
    animatePlacesLoop() {
      const markerElements = gsap.utils.toArray('.gsap-png-marker');
      const circleElements = gsap.utils.toArray('.gsap-winner-circle');
      gsap.set(markerElements, {
        opacity: 0,
        scale: 0
      });
      gsap.set(circleElements, {
        opacity: 0
      });
      const mainTimeline = gsap.timeline({
        delay: 2.5,
        repeat: -1,
        repeatDelay: 0
      });

      markerElements.forEach((marker, index) => {
        const circle = circleElements[index];
        const isTopWin = marker.classList.contains('top-win-marker');
        let extraDuration = 0;
        if (isTopWin) {
          extraDuration = 2;
        }
        const pairTimeline = gsap.timeline();
        let markerScale = 1;
        if (isTopWin) {
          markerScale = 1.2;
        }
        pairTimeline.to(marker, {
          opacity: 1,
          scale: markerScale,
          duration: 0.75,
          ease: isTopWin ? 'back.out(4)' : 'power4.out',
          onStart: () => {
            if (isTopWin) {
              const pyro = marker.querySelector('.pyro');
              if (pyro) {
                pyro.classList.add('pyro-active');
              }
            }
          }
        }, 0);
        pairTimeline.to(marker, {
          opacity: 0,
          scale: 0,
          duration: 0.75,
          onComplete: () => {
            if (isTopWin) {
              const pyro = marker.querySelector('.pyro');
              if (pyro) {
                pyro.classList.remove('pyro-active');
              }
            }
          }
        }, 1.5 + extraDuration);

        pairTimeline.to(circle, {
          opacity: 1,
          duration: 0.75,
          ease: 'power1.out'
        }, 0);
        pairTimeline.to(circle, {
          opacity: 1,
          duration: 2.50 + extraDuration
        }, 0.75);
        pairTimeline.to(circle, {
          opacity: 0,
          duration: 0.50,
          ease: 'power1.in'
        }, 3.25 + extraDuration);
        mainTimeline.add(pairTimeline, index * 0.75);
      });
    },
    addElements() {
      let resultsPane = map.getPane('results');
      if (!resultsPane) {
        resultsPane = map.createPane('results');
        resultsPane.style.zIndex = 651;
        resultsPane.style.pointerEvents = 'none';
      }
      let startOverlayPane = map.getPane('start-overlay');
      if (!startOverlayPane) {
        startOverlayPane = map.createPane('start-overlay');
        startOverlayPane.style.zIndex = 652;
        startOverlayPane.style.pointerEvents = 'none';
        startOverlayPane.classList.add('gsap-start-overlay-pane');
      }
      leaflet.rectangle(worldRectangleBounds, {
        color: 'rgba(32, 115, 229, 1)',
        weight: 0,
        fillOpacity: 1,
        pane: 'start-overlay'
      }).addTo(map);
      sweRec = leaflet.rectangle(sweRectangleBounds, {
        color: 'yellow',
        fillOpacity: 0.6,
        weight: 1
      });
      if (results.length) {
        results.forEach(result => {
          const lat = parseFloat(result.location.latitude.replace(',', '.'));
          const lng = parseFloat(result.location.longitude.replace(',', '.'));
          const winCoord = [lat, lng];
          const resTopWin = result.topWinAmountSek;
          const winAmount = parseFloat(resTopWin.replace(',', '.').replace(/\s/g, ''));
          const isHighestTopWin = winAmount >= 1000000;
          const markerClassName = "png-marker gsap-png-marker text-marker".concat(isHighestTopWin ? ' top-win-marker' : '');
          const pngIcon = get3dPinIcon({
            winAmount,
            color: 'green',
            className: markerClassName
          });
          const pngMarker = leaflet.marker(winCoord, {
            icon: pngIcon,
            pane: 'results',
            zIndexOffset: 200
          });
          pngMarker.addTo(map);
          markers.push(pngMarker);
          const circleClassName = "gsap-winner-circle".concat(isHighestTopWin ? ' top-win' : '');
          const leafletCircle = leaflet.circle(winCoord, {
            radius: result.maxDistanceMeters,
            color: '#1046B7',
            weight: 1,
            fillColor: '#1046B7',
            fillOpacity: 0.18,
            className: circleClassName,
            pane: 'results',
            bubblingMouseEvents: false
          });
          leafletCircle.addTo(map);
          circles.push(leafletCircle);
        });
      }
    },
    removeMap() {
      if (_isDestroying) {
        return;
      }
      _isDestroying = true;

      try {
        gsap.killTweensOf('.gsap-result-text-top');
        gsap.killTweensOf('.gsap-png-marker');
        gsap.killTweensOf('.gsap-winner-circle');
        if (tlEnd) {
          tlEnd.kill();
          tlEnd = null;
        }
      } catch (err) {
        logger.debug('Start map, GSAP not removed properly:', err);
      }

      try {
        if (map) {
          map.off('resize');
        }
      } catch (err) {
        logger.debug('Start map, map listeners not removed properly:', err);
      }

      try {
        if (map && typeof map.closePopup === 'function') {
          map.closePopup();
        }
      } catch (err) {
        logger.debug('Start map, error closing map popup:', err);
      }
      try {
        if (map && typeof map.closeTooltip === 'function') {
          map.closeTooltip();
        }
      } catch (err) {
        logger.debug('Start map, error closing map tooltip:', err);
      }

      try {
        markers.forEach(marker => {
          if (marker && marker.remove) {
            marker.remove();
          }
        });
        markers = [];
      } catch (err) {
        logger.debug('Start map, error removing markers:', err);
      }

      try {
        circles.forEach(circle => {
          if (circle && circle.remove) {
            circle.remove();
          }
        });
        circles = [];
      } catch (err) {
        logger.debug('Start map, error removing circles:', err);
      }

      try {
        if (sweRec && sweRec.remove) {
          sweRec.remove();
        }
        sweRec = null;
      } catch (err) {
        logger.debug('Start map, error removing Sweden rectangle:', err);
      }

      try {
        var _options;
        const container = (_options = options) !== null && _options !== void 0 && _options.nodeId ? document.getElementById(options.nodeId) : null;
        container === null || container === void 0 || container.querySelectorAll('.gsap-png-marker, .gsap-winner-circle, .gsap-result-text-top').forEach(el => el.remove());
      } catch (err) {
        logger.debug('Start map, error removing DOM elements:', err);
      }

      try {
        if (map) {
          map.off();
          map.remove();
        }
        map = null;
      } catch (err) {
        logger.debug('Start map, the map is not removed properly:', err);
      }

      options = null;
      results = null;
      _isDestroying = false;
    }
  };
}
Object.assign(svs.lyckoplatsen.components.shared_map, {
  getStartMapHandler
});

 })(window);